import React, { useEffect, useState, Suspense, lazy } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../redux/loaderSlice';
import { submitAdmissionForm } from '../redux/admissionFormSlice';

// Lazy-loaded components
const Poster = lazy(() => import('../components/Poster'));
const About = lazy(() => import('../components/About'));
const Info = lazy(() => import('../components/Info'));
const Awards = lazy(() => import('../components/Awards'));
const Facilities = lazy(() => import('../components/Facilities'));
const List = lazy(() => import('../components/List'));
const VardaanNews = lazy(() => import('../components/VardaanNews'));
const Pedagogy = lazy(() => import('../components/Pedagogy'));
const Testimonials = lazy(() => import('../components/Testimonials'));

const Home = () => {
  const initialFormData = {
    studentName: '',
    parentName: '',
    email: '',
    phone: '',
    grade: ''
  };

  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [warning, setWarning] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [crrYear, setCrrYear] = useState(new Date().getFullYear());

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setFormData(initialFormData);
    setShow(true);
  }

  useEffect(() => {
    if(new Date().getMonth()>10){
      setCrrYear(new Date().getFullYear()+1)
    }else{
      setCrrYear(new Date().getFullYear())
    }
    setShow(true);
  }, []);

  const handleClick = (link) => {
    window.open(link, "_blank");
  };

  const handleChange = (e) => {
    setWarning(false);
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    dispatch(showLoader());    
    e.preventDefault(); // Prevent page reload
    
    if(formData.studentName && formData.phone){
      setWarning(false);
      const submitForm = await dispatch(submitAdmissionForm(formData));
      dispatch(hideLoader());
      
      if(submitForm.payload.success){
        showAlert();
      }else{
        showError();
      }
      handleClose();
    }else{
      setWarning(true);
      dispatch(hideLoader());
    }
  };

  const showAlert = () => {
    window.Swal.fire({
      title: 'Success!',
      text: 'Your form has been submitted successfully.',
      icon: 'success',
      confirmButtonText: 'OK'
    });
  };

  const showError = () => {
    window.Swal.fire({
      title: 'Error!',
      text: 'Something went wrong.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
  };

  return (
    <div>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Admissions Open {crrYear}-{(crrYear+1).toString().substring(2)}<br />Enquire Now</Modal.Title>            
          </Modal.Header>
          <Modal.Body>
            {warning && <p className='warning-text'>*Student name and phone number are mandatory!!!</p>}
            <Form>
              <Form.Group className="mb-3" controlId="studentName">
                <Form.Label>Student Name *</Form.Label>
                <Form.Control type="text" placeholder="Student Name" value={formData.studentName} onChange={handleChange} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="parentName">
                <Form.Label>Parent Name</Form.Label>
                <Form.Control type="text" placeholder="Parent Name" value={formData.parentName} onChange={handleChange} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="Email" value={formData.email} onChange={handleChange} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control type="number" placeholder="Phone Number" value={formData.phone} onChange={handleChange} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="grade">
                <Form.Label>Grade</Form.Label>
                <Form.Select aria-label="Default select example" value={formData.grade} onChange={handleChange}>
                  <option value="12">Grade 12(Science)</option>
                  <option value="12">Grade 12(Commerce)</option>
                  <option value="12">Grade 12(Humanities)</option>
                  <option value="11">Grade 11(Science)</option>
                  <option value="11">Grade 11(Commerce)</option>
                  <option value="11">Grade 11(Humanities)</option>
                  <option value="10">Grade 10</option>
                  <option value="9">Grade 9</option>
                  <option value="8">Grade 8</option>
                  <option value="7">Grade 7</option>
                  <option value="1">Grade 7</option>
                  <option value="2">Grade 6</option>
                  <option value="3">Grade 5</option>
                  <option value="4">Grade 4</option>
                  <option value="5">Grade 3</option>
                  <option value="6">Grade 2</option>
                  <option value="7">Grade 1</option>
                  <option value="4">UKG</option>
                  <option value="5">LKG</option>
                  <option value="6">Nursery</option>
                  <option value="7">Playgroup</option>
                </Form.Select>
              </Form.Group>                            
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <Suspense fallback={<div>Loading...</div>}>
          <Poster />
          <About />
          <Info />
          <Awards />
          <Facilities />
          <List />
          <VardaanNews />
          <Pedagogy />
          <Testimonials />
        </Suspense>

        <div className='buttons'>
          <Button as="a" variant="primary" className='admission_btn' onClick={handleShow}>
            Admission Open
          </Button>
          <div className='wtsap_btn' onClick={()=>handleClick("https://wa.me/919799145119")}>
            <img src='https://images.vardaanschool.org/icons/whatsapp.webp' className='yt_icon' alt='whatsapp' loading='lazy' />
            <span className='icon_text'>Whatsapp</span>
          </div>
          <div className='fb_btn' onClick={()=>handleClick("https://www.facebook.com/share/15ABdtTfRR/")}>
            <img src='https://images.vardaanschool.org/icons/facebook.webp' className='yt_icon' alt='facebook' loading='lazy' />
            <span className='icon_text'>Facebook</span>
          </div>
          <div className='insta_btn' onClick={()=>handleClick('https://www.instagram.com/vardaan_group_of_schools?utm_source=qr')}>
            <img src='https://images.vardaanschool.org/icons/instagram.webp' className='yt_icon' alt='instagram' loading='lazy' />
            <span className='icon_text'>Instagram</span>
          </div>
          <div className='yt_btn' onClick={()=>handleClick('https://www.youtube.com/@vardaanschooldungarpur4830')}>
            <img src='https://images.vardaanschool.org/icons/youtube.webp' className='yt_icon' alt='youtube' loading='lazy' />
            <span className='icon_text'>Youtube</span>
          </div>
        </div>
    </div>
  )
}

export default Home
